// Because Typescript doesn't support arrow functions for assertions.
// eslint-disable-next-line func-style
export function assert(condition: boolean, message?: string): asserts condition {
    if (!condition) {
        throw new Error(message ?? "Assertion failed");
    }
}
